import { defineMessages } from '@/i18n';

export const fieldMessages = defineMessages({
  emptyValue: 'field.emptyValue',
});

export const actionMessages = defineMessages({
  send: 'actions.send',
  cancel: 'actions.cancel',
  close: 'actions.close',
  done: 'actions.done',
  continue: 'actions.continue',
  add: 'actions.add',
  edit: 'actions.edit',
  reset: 'actions.reset',
  saveAsDraft: 'actions.saveAsDraft',
  save: 'actions.save',
  startAgain: 'actions.startAgain',
  withdraw: 'actions.withdraw',
  accept: 'actions.accept',
  acceptAndPay: 'actions.acceptAndPay',
  viewDetails: 'actions.viewDetails',
  delete: 'actions.delete',
  download: 'actions.download',
  upload: 'actions.upload',
  preview: 'actions.preview',
  sign: 'actions.sign',
  leave: 'actions.leave',
  paymentLink: 'actions.paymentLink',
  next: 'actions.next',
  back: 'actions.back',
  retry: 'actions.retry',
  seeAll: 'actions.seeAll',
  select: 'actions.select',
  exportCSV: 'actions.exportCSV',
  loadMore: 'actions.loadMore',
  confirmationLink: 'actions.confirmationLink',
  dismiss: 'actions.dismiss',
  checkStatus: 'actions.checkStatus',
  verifyAccount: 'actions.verifyAccount',
});

export const notificationMessages = defineMessages({
  success: 'platform.app.gallery.notifications.success',
  error: 'platform.app.gallery.notifications.error',
});

export const dimensionMessages = defineMessages({
  dimensionTitleDuration: 'platform.app.gallery.artworks.dimensionTitleDuration',
  dimensionTitleVolume: 'platform.app.gallery.artworks.dimensionTitleVolume',
  dimensionTitleOther: 'platform.app.gallery.artworks.dimensionTitleOther',
  dimensionTitlePhysical: 'platform.app.artworks.detail.dimensions',
  heightLabelShort: 'platform.app.gallery.artworks.heightLabelShort',
  widthLabelShort: 'platform.app.gallery.artworks.widthLabelShort',
  depthLabelShort: 'platform.app.gallery.artworks.depthLabelShort',
});
